import { render } from "./index.vue?vue&type=template&id=f084d7a8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f084d7a8&lang=scss"
script.render = render

export default script